 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import HTML00_COVER from '@/components/html/00_Cover'
 import HTMLLOVE_1 from '@/components/html/love_1'
 import HTML01_TITLE_PAGE from '@/components/html/01_Title_Page'
 import HTML02_COPYRIGHT from '@/components/html/02_Copyright'
 import HTML03_DEDICATION from '@/components/html/03_Dedication'
 import HTML04_CONTENTS from '@/components/html/04_Contents'
 import HTML05_INTRODUCTION__WHO_IS_ROBERT_E__H from '@/components/html/05_INTRODUCTION__Who_Is_Robert_E__H'
 import HTML06_CHAPTER_ONE__PIONEERING_STORIES from '@/components/html/06_CHAPTER_ONE__Pioneering_Stories'
 import HTML07_CHAPTER_TWO__FROM_BIRTH_TO_BAGWE from '@/components/html/07_CHAPTER_TWO__From_Birth_to_Bagwe'
 import HTML08_CHAPTER_THREE__CROSS_CUT_AND_BUR from '@/components/html/08_CHAPTER_THREE__Cross_Cut_and_Bur'
 import HTML09_CHAPTER_FOUR__THE_BIRTH_OF_A_WRI from '@/components/html/09_CHAPTER_FOUR__The_Birth_of_a_Wri'
 import HTML10_CHAPTER_FIVE__TATTLERS_AND_YELLO from '@/components/html/10_CHAPTER_FIVE__Tattlers_and_Yello'
 import HTML11_CHAPTER_SIX__PULP_FICTIONEER from '@/components/html/11_CHAPTER_SIX__Pulp_Fictioneer'
 import HTML12_CHAPTER_SEVEN__THE_OTHER_SIDE_OF from '@/components/html/12_CHAPTER_SEVEN__The_Other_Side_of'
 import HTML13_CHAPTER_EIGHT__A_NEW_SPECIES_OF from '@/components/html/13_CHAPTER_EIGHT__A_New_Species_of'
 import HTML14_CHAPTER_NINE__FRIENDS_AND_LETTER from '@/components/html/14_CHAPTER_NINE__Friends_and_Letter'
 import HTML15_CHAPTER_TEN__NOVALYNE_PRICE from '@/components/html/15_CHAPTER_TEN__Novalyne_Price'
 import HTML16_CHAPTER_ELEVEN__BROKEN_ON_THE_PL from '@/components/html/16_CHAPTER_ELEVEN__Broken_on_the_Pl'
 import HTML17_CHAPTER_TWELVE__THE_AFTERMATH from '@/components/html/17_CHAPTER_TWELVE__The_Aftermath'
 import HTML18_CHAPTER_THIRTEEN__WRITING_A_LEGA from '@/components/html/18_CHAPTER_THIRTEEN__Writing_a_Lega'
 import HTML19_CHAPTER_FOURTEEN__FULL_CIRCLE__T from '@/components/html/19_CHAPTER_FOURTEEN__Full_Circle__T'
 import HTMLLOVE_2 from '@/components/html/love_2'
 import HTML20_AFTERWORD from '@/components/html/20_Afterword'
 import HTML21_ACKNOWLEDGMENTS from '@/components/html/21_Acknowledgments'
 import HTML22_NOTES from '@/components/html/22_Notes'
 import HTML23_INDEX from '@/components/html/23_Index'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/html/04_Contents",
 			"name" : "html/04_Contents",
 			"component" : HTML04_CONTENTS
 		},
 		{
 			"path" : "/html/05_INTRODUCTION__Who_Is_Robert_E__H",
 			"name" : "html/05_INTRODUCTION__Who_Is_Robert_E__H",
 			"component" : HTML05_INTRODUCTION__WHO_IS_ROBERT_E__H
 		},
 		{
 			"path" : "/html/06_CHAPTER_ONE__Pioneering_Stories",
 			"name" : "html/06_CHAPTER_ONE__Pioneering_Stories",
 			"component" : HTML06_CHAPTER_ONE__PIONEERING_STORIES
 		},
 		{
 			"path" : "/html/07_CHAPTER_TWO__From_Birth_to_Bagwe",
 			"name" : "html/07_CHAPTER_TWO__From_Birth_to_Bagwe",
 			"component" : HTML07_CHAPTER_TWO__FROM_BIRTH_TO_BAGWE
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js